import { Link } from 'react-router-dom'
import '../Footer/styles.css'
 
export function Footer() {
    return (
        <>
        <footer className="footer">
            <span className="textFooter"><i className="far fa-copyright"></i>2022 - Busca Saúde. Todos os direitos reservados</span><br></br>
            <span className="textFooter"><Link to="/termos-de-uso" style={{color: '#FFF', textDecoration: 'none'}}>Termos de uso</Link></span>
            <div>

            </div>

        </footer>
        </>
    )
}
